export const userType = {admin: 1, submitter: 2, viewer: 3, manager: 4};
